export const LIGHT_GRAY_BACKGROUND = 'lightGray';
export const PAPER_BACKGROUND = 'paper';
export const DEFAULT_BACKGROUND = 'default';
